import {
    Caption,
    Subheader,
    useAppDisplayModeContext,
} from '@archipro-design/aria';
import { useStyles } from '@archipro-design/aria';
import { useGetStartedAction } from '~/modules/design-board/hook';
import * as S from './NoPinWithUpload.style';
import { CallToActionImageGrid } from '~/modules/design-board/component/shared/CallToActionImageGrid';
import { useUploadPin } from '~/modules/design-board/hook/use-upload-pin';

interface NoPinWithUploadProps {
    canUploadFile: boolean;
}

const NoPinWithUpload = ({ canUploadFile }: NoPinWithUploadProps) => {
    const { mobile } = useAppDisplayModeContext();
    const { getStartedButton } = useGetStartedAction('/');

    const { handleDrag, handleDrop, isDragActive, onUploadClick, hiddenInput } =
        useUploadPin({ mobile });

    const { css } = useStyles({ isDragActive });

    return mobile ? (
        <div className={css(S.NoPinMobile)}>
            <div className={css(S.NoPinContentMobile)}>
                <Caption>
                    This board is ready. Start saving pins to this board by
                    browsing ArchiPro.
                </Caption>
            </div>
            {getStartedButton}
        </div>
    ) : (
        <>
            <div
                className={css(S.NoPinWithUpload)}
                onDragEnter={handleDrag}
                onDragLeave={handleDrag}
                onDragOver={handleDrag}
                onDrop={handleDrop}
            >
                <Subheader>
                    {isDragActive ? `Drop files here` : `This board is ready.`}
                </Subheader>

                {!isDragActive && (
                    <Caption>
                        Start saving pins by browsing ArchiPro
                        {canUploadFile ? (
                            <>
                                &nbsp;or{' '}
                                <span onClick={onUploadClick}>upload</span>{' '}
                                documents directly by dragging them to this
                                board.
                            </>
                        ) : (
                            '.'
                        )}
                    </Caption>
                )}

                {hiddenInput}
            </div>
            <div className={css(S.CallToActionContainer)}>
                <CallToActionImageGrid />
            </div>
        </>
    );
};

export default NoPinWithUpload;
